const styles = theme => ({
  root: {
  },
  stepper: {
    backgroundColor: 'rgba(240,240,240,0.1)',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  input: {
    marginTop: 24,
    marginBottom: 24,
  },
  actionsContainer: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  resetContainer: {
    marginTop: 0,
    padding: theme.spacing.unit * 3, // TODO: See TODO note on Stepper
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/components/CoreLayout/styles.js